import { http } from "./config";

export default {
  get: () => http.get("configuracao-sistema"),
  update: (form) => http.put("configuracao-sistema", form),
};
